<template>
  <pt-manual-reward class="pt-manual-reward__page"></pt-manual-reward>
</template>

<script>
import PtManualReward from 'cps/new-to-old-audit/pt-manual-reward/withData'
export default {
  name: 'pt-manual-reward__view',
  components: {
    'pt-manual-reward': PtManualReward
  }
}
</script>
